import React from "react";
import Button from "../../components/button/button";
import closedImage from "../../assets/mission_image.png";
import { Link } from "react-router-dom";
import Section from "../../components/section";
import background from "../../assets/backgrounds/landing-3.svg";

const AnchoringConversations: React.FC = () => {
  return (
    <Section backgroundImage={background} id="events">
      <div className="flex flex-col items-center justify-center mx-auto px-4 min-h-screen">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-white mb-8">
          Close Circles: Anchoring Dialogues
        </h2>
        <div className="md:flex md:items-center">
          <div className="md:w-1/2">
            <p className="text-white text-opacity-80 text-3xl font-semibold sm:text-4xl mb-4 text-center">
              Join Our <span className="text-orange-400">Flagship </span>Event
            </p>
            <p className="text-gray-200 text-opacity-90 sm:text-2xl mb-8 text-center">
              At Close Circles, we bring together policymakers, professionals,
              and youth to engage in fervent discussions about pressing social
              issues. Our platform is a{" "}
              <span className="font-bold">safe harbour</span> for collaboration
              and understanding.
            </p>
            <div className="flex justify-center">
              <Link to="/anchoring_conversations">
                <Button theme="primary">Find Out More</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <img
        src={closedImage}
        className="hidden md:block absolute top-1/2 left-2/3 rotate-12 aspect-square w-[40vh]"
      />
    </Section>
  );
};

export default AnchoringConversations;
